import { Form } from '@calendly/form'
import { usePageTitle } from '@calendly/hooks'
import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { Link } from '@calendly/ui/components/link'
import { useDispatch, useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'

import { saveOrgInvitationPermissionsSettings } from 'actions/current_organization'
import { SETTINGS_SECTION } from 'features/settings_modal/constants'
import { useSettingsNavigation } from 'features/settings_modal/use_settings_navigation'
import { isScimConfiguredSelector, orgInvitationPermissionsSelector } from 'selectors/current_organization'

import { Description, Question } from '../styles'
import { FormContent } from './form_content'

const BillingLink = ({ children }) => {
  const { hrefForSettingsSection, isSettingsModalNavigationActive } = useSettingsNavigation()

  if (isSettingsModalNavigationActive) {
    return (
      <Link as={RouterLink} to={hrefForSettingsSection(SETTINGS_SECTION.adminBilling, '/app/admin/billing')}>
        {children}
      </Link>
    )
  }

  return (
    <Link href="/app/admin/billing" target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  )
}

export const Invitations = () => {
  const dispatch = useDispatch()
  const isScimEnabled = useSelector(isScimConfiguredSelector)
  const invitationPermissionsRole = useSelector(orgInvitationPermissionsSelector)

  const pageTitlePostfix = I18n.t('publisher.admin.permissions.title')

  usePageTitle(`${I18n.t('publisher.organization_settings.invitations.title')} - ${pageTitlePostfix}`)

  return (
    <>
      {
        isScimEnabled && (
          <ContextualBanner variant="warning" spacingBottom={16}>
            {I18n.t('publisher.organization_settings.invitations.scim_banner')}
          </ContextualBanner>
        )
      }
      <Description>
        {HtmlParser(I18n.t('publisher.organization_settings.invitations.description'), { BillingLink })}
      </Description>
      <Question>
        {I18n.t('publisher.organization_settings.invitations.question')}
      </Question>
      <Form
        initialValues={{ invitation_permissions_enabled_for: invitationPermissionsRole }}
        onSubmit={(newRole) => dispatch(saveOrgInvitationPermissionsSettings(newRole))}
      >
        <FormContent />
      </Form>
    </>
  )
}
